import { queryKeys } from '../constants';

const MODULE_KEY = 'academicYears';

/** Query Key Getters */

export const getAcademicYearsQueryKey = () => [MODULE_KEY, queryKeys.GET_ACADEMIC_YEARS];
